export const getNews = async (id: string) => {
	const url = new URL(`${process.env.NEXT_PUBLIC_BASE_URL}/api/news/${id}`);

	const res = await fetch(url.toString(), {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
		cache: "no-store",
	});

	if (!res.ok) throw new Error("Failed to fetch news");
	return res.json();
};
